import { Bot, Zap, type LucideIcon } from '../icons';

/**
 * AI 메뉴의 하위 화면 — **한 곳**에 둔다 (설계 판 A · 정의서 M1).
 *
 * 근태(`att-menu.ts`)와 같은 규칙이다: 화면이 목록을 따로 갖지 않는다. 하위가 늘면 이 파일만 고친다.
 *
 * ★★★ **정의서 M1 의 셋이 다 섰다.** 「대화」(판 A·B·C) · 「에이전트」(판 E) ·
 *    **「업무자동화」(판 X1 · 2026-09-10)**. 마지막 것은 오래 **안 세워 두었다** — 표도 실행기도
 *    없어서 눌러도 갈 곳이 없었기 때문이다(「할 수 없는 일을 메뉴에 세우면 그게 잘못된 안내」).
 *    이제 표·cron·워커·라우트가 다 있으므로 세운다.
 */

/** AI 메뉴의 뿌리 — 「전체」가 가는 곳이자 레일 메뉴의 주소다. */
export const AI_HOME_PATH = '/ai';

export interface AiMenuItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** 줄 아래 한 줄 곁말 — 「무엇을 하는 곳인가」. */
  hint: string;
}

/** 에이전트 목록의 주소 — 화면과 메뉴가 같은 값을 본다. */
export const AI_AGENTS_PATH = '/ai/agents';

/** 업무자동화 목록의 주소 (판 X1). */
export const AI_AUTOMATIONS_PATH = '/ai/automations';

/**
 * 레일에 서는 하위 화면.
 *
 * ★★★ **「대화」는 여기 없다** (2026-09-11 사용자 지시) — 대화로 가는 길은 **이력을 누르는 것**과
 *   **「새 대화」 단추**, 둘 다 바로 위에 있다. 메뉴에 또 두면 같은 곳으로 가는 길이 셋이 되고,
 *   업무자동화를 보다가 지난 대화로 가려면 **「대화」를 누른 뒤 다시 이력을 눌러야** 했다.
 *   주소(`/ai`)는 그대로다 — **메뉴에서만 뺀 것**이다.
 */
export const AI_MENU: AiMenuItem[] = [
  { to: AI_AGENTS_PATH, label: '에이전트', icon: Bot, hint: '역할과 답변 규칙을 정해 둔다' },
  { to: AI_AUTOMATIONS_PATH, label: '업무자동화', icon: Zap, hint: '정해 둔 때가 되면 스스로 묻는다' },
];
